import DictionaryFactory from "./dictionary-factory";

/**
 * 缓存字典的键
 * @param factoryName 字典工厂名称
 * @param params 字典工厂获取字典的查询参数，该参数为string值，或者是一层简单对象
 * @returns {string} 缓存字典的键
 */
export function getCacheDictionaryKey(factoryName, params) {
    let paramsKey;
    let type = Object.prototype.toString.call(params).slice(8, -1).toLowerCase();
    if (type === 'string') {
        paramsKey = params;
    } else {
        let paramKeys = [];
        for (let param in params) {
            if (params.hasOwnProperty(param) && params[param] != null) {
                paramKeys.push(`${param}=${params[param]}`);
            }
        }
        paramsKey = paramKeys.join('&');
    }
    return `${factoryName}______${paramsKey}`;
}

/**
 * 字典容器
 */
export default class DictionaryContainer {

    constructor({dictionaryCache = new Map(), factoryCache = new Map()} = {}) {
        this.dictionaryCache = dictionaryCache;
        this.factoryCache = factoryCache;
    }

    /**
     * 获取字典
     * @param factoryName
     * @param params 参数
     */
    getDictionary(factoryName, params) {
        let dictionary;
        let key = getCacheDictionaryKey(factoryName, params);
        if (this.hasDictionary(key)) {
            dictionary = this.dictionaryCache.get(key);
        } else {
            let factory = this.factoryCache.get(factoryName);
            if (factory == null) {
                throw `${factoryName} factory do not register.`;
            }
            if (factory instanceof DictionaryFactory) {
                dictionary = factory.getDictionary(params);
                this.registerDictionary(key, dictionary);
            } else {
                throw `${factoryName} factory is not DictionaryFactory.`;
            }
        }
        return dictionary;
    }

    /**
     *
     * @returns {boolean}
     */
    hasDictionary(key) {
        return this.dictionaryCache.has(key);
    }

    /**
     * 注册字典
     * @param key
     * @param dictionary
     * @returns {boolean}
     */
    registerDictionary(key, dictionary) {
        return this.dictionaryCache.set(key, dictionary);
    }

    registerFactory(factory) {
        return this.factoryCache.set(factory.name, factory);
    }

}